import React from "react";

import { faPencil } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  ActionButton,
  ActionButtonContainer,
} from "components/AgGrid/ActionButton";

import { openModalLink } from "lib/navigation";

export function GeneralEditRenderer({ value, data, idKey, modalType }) {
  if (data && modalType && idKey && typeof value === "string" && value !== "") {
    const onClickEdit = value
      ? () => {
          openModalLink(modalType, {
            [idKey]: value,
          });
        }
      : null;

    return (
      <ActionButtonContainer>
        <ActionButton onClick={onClickEdit}>
          <FontAwesomeIcon icon={faPencil} />
          &nbsp;Edit
        </ActionButton>
      </ActionButtonContainer>
    );
  } else {
    return null;
  }
}
